<div class="heading-tab">
  <h3 class="heading"><i nz-icon nzType="reconciliation" nzTheme="outline"></i> Treating Doctor Details</h3>
  <button nz-button nzType="primary" (click)="modDocDetails=true">Add Doctor Details</button>
</div>
<nz-table [nzData]="dataSet" [nzShowPagination]="false">
  <thead>
    <tr>
      <th>Doctor Name</th>
      <th>Doctor Details</th>
      <th>Regn. Details</th>
      <th>Treated For</th>
      <th>Remarks</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Dr. John Dorian</td>
      <td>Partner Hosp.</td>
      <td>RGNF09993883</td>
      <td>Angioplasty</td>
      <td>--</td>
      <td><a>Edit</a> | <a nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
          nzCancelText="Cancel">Remove</a></td>
    </tr>
    <tr>
      <td>Dr. Rakesh Gupta</td>
      <td>Partner Hosp.</td>
      <td>RGNF09993883</td>
      <td>Sudden chest pain</td>
      <td>No complications</td>
      <td><a>Edit</a> | <a nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
          nzCancelText="Cancel">Remove</a></td>
    </tr>
  </tbody>
</nz-table>

<!-- Doctor Details : Add -->
<nz-modal [(nzVisible)]="modDocDetails" nzTitle="Add Doctor Details" (nzOnCancel)="modDocDetails=false"
  (nzOnOk)="modDocDetails=false" nzOkText="Add" nzWidth="75%">
  <div *ngIf="modDocDetails">
    <div class="tab-grid m-t-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Doctor Name</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Registration No.</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Details</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder="Additional details"></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Treated for</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder=""></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Remarks</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input nzAutosize placeholder="Remarks"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>
</nz-modal>